import React from 'react';

const Loader = () => (
  <div className="loader">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="0"
      height="0"
      viewBox="0 0 567.66 150.43"
    >
      <polygon
        points="188.1 136.97 188.1 140.03 193 140.03 193 143.19 188.1 143.19 188.1 150.06 184.84 150.06 184.84 133.78 196.49 133.78 196.49 136.97 188.1 136.97"
        fill="#231f20"
      />
      <rect x="204.24" y="133.78" width="3.26" height="16.27" fill="#231f20" />
      <path
        d="M226.82,150.06l-6-8.89c-.4-.6-.93-1.42-1.14-1.83,0,.6,0,2.65,0,3.55v7.17h-3.21V133.78h3.11l5.77,8.6c.39.61.93,1.42,1.14,1.84,0-.6,0-2.65,0-3.56v-6.88h3.21v16.28Z"
        fill="#231f20"
      />
      <path
        d="M243.4,150.06h-4.85V133.78h5.09c4.64,0,8.08,2.18,8.08,8.14,0,5.72-4.13,8.14-8.32,8.14m.12-13.12H241.8v9.95h1.6c3.42,0,5-2,5-5,0-3.33-1.42-5-4.86-5"
        fill="#231f20"
      />
      <path
        d="M284.82,150.06h-3.18l-2-8.37c-.23-1-.47-2.19-.56-2.8-.07.61-.3,1.84-.53,2.8l-2.05,8.37h-3l-3.4-16.28h3.4l1.41,7.93c.14.79.33,2,.4,2.67.12-.67.37-1.88.56-2.67l1.9-7.93h2.84l1.93,7.93c.18.79.44,2,.56,2.67.07-.67.25-1.9.39-2.67l1.42-7.93h3.35Z"
        fill="#231f20"
      />
      <polygon
        points="306.03 150.06 306.03 143.22 299.35 143.22 299.35 150.06 296.1 150.06 296.1 133.78 299.35 133.78 299.35 140.01 306.03 140.01 306.03 133.78 309.28 133.78 309.28 150.06 306.03 150.06"
        fill="#231f20"
      />
      <path
        d="M328.93,150.06l-1.28-3.63H321.7l-1.28,3.63h-3.49l6.23-16.28h3.17l6.18,16.28Zm-3.44-9.68c-.33-.95-.65-1.93-.82-2.53-.16.6-.48,1.58-.81,2.53l-1,3h3.72Z"
        fill="#231f20"
      />
      <polygon
        points="344.84 136.99 344.84 150.06 341.58 150.06 341.58 136.99 336.91 136.99 336.91 133.78 349.51 133.78 349.51 136.99 344.84 136.99"
        fill="#231f20"
      />
      <path
        d="M380.63,150.06v-6c0-.89.05-3,.05-3.58-.23.6-.72,1.77-1.14,2.69l-3.3,7.24-3.3-7.24c-.42-.92-.9-2.09-1.14-2.69,0,.63.05,2.69.05,3.58v6h-3.19V133.78h3.14l3.4,7.37c.41.91.9,2.14,1.11,2.72.21-.61.68-1.79,1.09-2.72l3.28-7.37h3.21v16.28Z"
        fill="#231f20"
      />
      <path
        d="M403.53,150.06l-1.28-3.63H396.3L395,150.06h-3.49l6.23-16.28h3.16l6.18,16.28Zm-3.44-9.68c-.32-.95-.65-1.93-.81-2.53-.16.6-.49,1.58-.82,2.53l-1,3h3.72Z"
        fill="#231f20"
      />
      <polygon
        points="419.44 136.99 419.44 150.06 416.19 150.06 416.19 136.99 411.51 136.99 411.51 133.78 424.12 133.78 424.12 136.99 419.44 136.99"
        fill="#231f20"
      />
      <polygon
        points="438.76 136.99 438.76 150.06 435.51 150.06 435.51 136.99 430.84 136.99 430.84 133.78 443.44 133.78 443.44 136.99 438.76 136.99"
        fill="#231f20"
      />
      <polygon
        points="451.21 150.06 451.21 133.78 462.51 133.78 462.51 136.97 454.46 136.97 454.46 139.78 459.14 139.78 459.14 142.94 454.46 142.94 454.46 146.87 462.86 146.87 462.86 150.06 451.21 150.06"
        fill="#231f20"
      />
      <path
        d="M480.39,150.06l-2.91-5.86h-3.27v5.86H471V133.78h7.58c3.07,0,5.61,1.7,5.61,5.16a4.64,4.64,0,0,1-3.12,4.79l3.12,6.33Zm-1.93-13.12h-4.25v4.19h4.25c1.51,0,2.33-.7,2.33-2.12s-.89-2.07-2.33-2.07"
        fill="#231f20"
      />
      <path
        d="M497.71,150.31a7.54,7.54,0,0,1-6.32-2.95l2.35-2.1a5.25,5.25,0,0,0,4.16,1.86c1.93,0,2.84-.53,2.84-1.76,0-1-.56-1.51-3.63-2.21S492,141.5,492,138.29c0-2.95,2.6-4.77,5.81-4.77a7.75,7.75,0,0,1,5.93,2.56l-2.35,2.28a5,5,0,0,0-3.7-1.67c-1.74,0-2.32.74-2.32,1.46,0,1,.7,1.35,3.28,1.95s5.44,1.5,5.44,5c0,3.09-2,5.18-6.4,5.18"
        fill="#231f20"
      />
      <path
        d="M237.51,64.15c2-.64,8.47-4.46,8.47-4.46C259.33,51.86,254.31,35,254.31,35c-5.38-16.16-23.72-20.4-23.72-20.4-38.35-9.22-60,12.08-60,12.08C152.14,44.31,160.22,64,160.22,64c4,7.93,7.2,6.14,7.2,6.14,2.55-1.43,9.21-5.76,9.21-5.76,3-2,.84-4.78.84-4.78a15.63,15.63,0,0,1-.87-11.63s1.52-7.39,9.65-13.53a43.59,43.59,0,0,1,29.47-8.07c10,1,17.1,4.6,19.76,12.48s-2.94,15.83-12.69,18-12.61-.2-12.61-.2c-1.82-.79,0-4.06,0-4.06a25,25,0,0,1,8.9-9.93c2.85-1.53,1.84-3.69,1.84-3.69a12.29,12.29,0,0,0-1.2-3.47c-1.92-3.94-5-3.39-5-3.39a17.85,17.85,0,0,0-9.78,2.52c-10.37,5.18-15.55,17.54-15.55,17.54l-15.17,31.3c-1.84,3.43-4.64,2.31-4.64,2.31L165.35,84a38.32,38.32,0,0,0-24-1.66c-15.9,5.62-14.06,18.55-14.06,18.55,1.81,10.48,12,16.89,25.29,16.21,15.11-.76,23-8,23-8,3.66-2.56,5.32-.75,5.32-.75l1.59.94c19.43,13,37.86,9.5,37.86,9.5,10.47-1.92,21.15-6,26-23.06,4.77-16.94-10-28.55-10-28.55C235,65.65,235.52,64.81,237.51,64.15ZM152.9,102.79c-8.75,1.1-9.49-3.48-9.49-3.48-1.15-4.44,4.9-6,4.9-6,9.33-2.13,14.22,3.68,14.22,3.68C161.62,102.05,152.9,102.79,152.9,102.79Zm72.35-7.19c-6.35,10.26-18.43,8.13-18.43,8.13-11.54-1.3-17.24-6.36-17.24-6.36-1.66-1,0-4.11,0-4.11s10-18.89,12-22.35a4.16,4.16,0,0,1,5.21-2.11c10,2.51,14.45,6.77,14.45,6.77C231.28,84.47,225.25,95.6,225.25,95.6Z"
        fill="#bd2332"
      />
      <path
        d="M277.25,51.27s-4.51-.86-7.39,5.24S254.07,90,254.07,90s-4.91,11.21-.57,18.15c0,0,3.35,6.59,14.95,6.11,0,0,10.65-.54,17.23-6.72,0,0,3.77-3.79,5.69.15,0,0,5,9.72,21.52,5.71,0,0,11.62-2.44,21.5-14.21,0,0,12.59-13.63,20.51-29,0,0,2.23-4.87,5.1-2.63a13.84,13.84,0,0,1,3.55,3.54s2,2.09-.62,6.33c0,0-6.58,12.76-7.82,18.49,0,0-2.61,11.06,4.79,15.68,0,0,8.82,6.45,23.61-1a64,64,0,0,0,15.17-13.58s9.52-11.4,13.78-19.64c0,0,3.44-6,4.11-7.83,0,0,1.88-5,5.3-1.77A22.59,22.59,0,0,1,425,71.19s1.28,2-.18,5.2-8.14,15.08-8.39,21.17c0,0-2.57,10.83,5.79,14.84,0,0,9.87,5,23.29-1.88,0,0,3.81-1.57,8.62-6.94,0,0,1.81,11,15.63,10.56,0,0,15.15.3,28-13.69,0,0,8.5-7.58,18.92-25.44,0,0,1-2.64,2.87-2.26,0,0,1.73-.79,1.37,5.62,0,0,0,5.18.49,10.13S520.12,100,515,101.7c0,0-1,.36-4.24-.49a6.94,6.94,0,0,0-5.42.69,56.36,56.36,0,0,0-5.45,2.74c-2.6,1.51-.72,3.4.28,4.23s7,4.12,16.52,5.42,26.17-3.36,34.65-10.74c0,0,5.68-4.49,15.72-18.12a2.27,2.27,0,0,0-.35-3.29,12.38,12.38,0,0,0-3.67-2.28s-1.86-1.19-4.09,1.73c0,0-7.86,11.42-14.6,16.08,0,0-3.18,2.37-3.55-.48,0,0-1.2-19-1-29.21a73.06,73.06,0,0,1,1-11.87,4.32,4.32,0,0,0-2.53-5.28L527.9,48.39s-4.89-2-7.09,2.71a239.7,239.7,0,0,1-18.74,30.14,65.05,65.05,0,0,1-20.31,20.39s-4.52,3.42-6.66-1.11c0,0-1.67-2.41,6.45-18.71l12.08-24.58s3.32-4.73-2.24-5.81l-13.85,0s-2.63-.38-4.92,4.6a219.41,219.41,0,0,1-18.75,34.53s-8.42,11.19-13.29,11.89c0,0-4.17.88-3.44-4.44,0,0,.52-6.76,8.18-20,0,0,3.36-6-.36-9.75a67,67,0,0,0-17.67-12.83s-2.52-1.15-1.53-3.5A25,25,0,0,1,428,47.21s1.77-3.32-3.9-5.41-7-.77-8.19,0c0,0-2.76,1.18-7.73,7.75,0,0-2.78,3.37.09,8.05,0,0,3.25,3.37.95,7.14,0,0-12.85,23.36-24.73,34.16,0,0-5.9,5.77-8.58,2,0,0-1.8-.8,2-10.12,0,0,4.18-9,6.73-14.47,0,0,2.93-4.18-2.26-9.17S372.12,59,365.75,55.33c0,0-3.52-.83-.7-5.1,0,0,2.92-5,.07-7.1a12.85,12.85,0,0,0-7.7-2.51S352.47,40.62,346,51c0,0-1.85,3.16,1.57,8,0,0,2.49,2.21-.17,6.47,0,0-5,10.08-20.06,28.62,0,0-7.48,8.64-13.24,8.79,0,0-5.06,1.18-3.59-5.36a372.33,372.33,0,0,1,17.4-37.32,20.23,20.23,0,0,0,1.87-4.88c.68-2.79-1.18-3.54-3.79-3.67s-12.33-.08-12.33-.08-3.81-.53-5.81,4.26S299,78.06,289.34,91.22c0,0-6.68,9.09-13.4,10.24,0,0-5.94-.14-2.74-7.21,0,0,5.17-12.7,16.51-34A17.94,17.94,0,0,0,292,55s.88-3.55-4.44-3.55Z"
        fill="#bd2332"
      />
      <path
        d="M504.5,36.72c0,5.61-5.35,10.17-11.94,10.17s-11.95-4.56-11.95-10.17S486,26.54,492.56,26.54,504.5,31.1,504.5,36.72Z"
        fill="#bd2332"
      />
      <circle
        cx="60.96"
        cy="61.56"
        r="56.83"
        transform="translate(-18.96 28.13) rotate(-22.58)"
        fill="#bd2332"
      />
      <path
        d="M61,0a61,61,0,1,0,61,61A61,61,0,0,0,61,0Zm0,7.23a53.76,53.76,0,0,1,49,75.83L64.7,19.22a4.65,4.65,0,0,0-6.6,0L12.33,83.81A53.73,53.73,0,0,1,61,7.23Z"
        fill="#231f20"
      />
      <polygon
        points="104.32 92.9 73.9 71.12 75.1 92.96 61.4 71.12 47.22 92.59 48.51 71.12 17.39 92.65 61.25 30.16 104.32 92.9"
        fill="#fff"
      />
    </svg>
    <div className="loading-text">Loading Burris Products</div>
  </div>
);

export default Loader;
